const share = {
  profile: 'Profile',
  share: 'Share',
  scan: 'Scan',
  publish: 'Publish',
}


export default share
